import { League } from './League';
import { Users } from 'models/UserCollection.jsx';

import React from 'react';
import { renderIntoContainer } from 'react/root/containerRoot';
import { Dashboard } from 'components/Dashboard';
import { declickables } from 'components/Declickables.jsx';
import { MapHelper } from 'functions/MapHelper.jsx';
import FeaturedStreamsComponent from 'react/stream/FeaturedStreamsComponent.jsx';
import StreamsTabStreamsComponent from 'react/stream/StreamsTabStreamsComponent.jsx';

import * as featuredStreamsActions from 'react/redux/actions/featuredStreams';
import * as popupActions from 'react/redux/actions/popups';
import store from 'react/redux/store/store';
import Game from 'models/Game';
import { Request } from '../components/Request';
import { Match } from './Match';
import { isNetplayPageActive } from 'react/netplay/netplayPageState';

class FeaturedStreams {
	constructor(container) {
		this.streams = new Map();
		if(!container) {
			throw new Error('Container needs to be defined');
		}
		this.container = container;
		this.filteredGames = new Map();
		this.sortStyle = 'viewers';

	}

	static retrieve(jqueryElement) {
		let streamData = jqueryElement.data('featuredStreams');
		if(!streamData) {
			streamData = new FeaturedStreams(jqueryElement);
			jqueryElement.data('featuredStreams', streamData);
		}
		return streamData;
	}

	afterUpdate({ showGames = true }) {
		console.error('dis this ever happen');
		const container = this.container;
		if(!isNetplayPageActive()) {
			return;
		}


		MapHelper.inPlaceSort(this.streams, ([_, a], [__, b]) => {
			if(this.sortStyle === 'league') {
				if(a.league.isEqualTo(b.league)) {
					return 0;
				}
				return a.league.isGreaterOrEqualTo(b.league) ? -1 : 1;
			}
			else if(this.sortStyle === 'viewers') {
				return a.viewers > b.viewers ? -1 : 1;
			}
			else {
				console.error('no sort style set');
			}
		});

		console.error('do something about featured streams');
		if(showGames) {
			renderIntoContainer(
				<StreamsTabStreamsComponent streams={this.streams} />,
				this.container[0],
			);
		}
		else {
			featuredStreamsActions.featuredStreamsUpdate(this.streams);
		}
	}
}

class Stream extends CacheableDataObject {
	afterConstruct() {
		this.element = null;
	}

	getUrl() {
		switch(this.type) {
			case 'image':
				return this.preview_url;
			case 'twitch':
				return `https://twitch.tv/${this.channel_name}`;
			case 'youtube':
				return `https://youtu.be/${this.id}`;
			default:
				return this.preview_url;
		}
	}

	followLink() {
		window.open(this.getUrl(), '_blank');
	}

	onClick(coordinates) {
		store.dispatch(popupActions.streamLinkClick(this, coordinates));
	}

	isPreviewable() {
		return !!this.preview_url || !!this.title;
	}

	static streamClick(button, { x: x, y: y }) {
		const streamObject = Stream.create({
			type: button.data('stream_type'),
			channel_name: button.data('channel_name'),
			literal: button.data('literal'),
			id: button.data('id'),
			preview_url: button.data('preview_url'),
		});
		streamObject.onClick({ x, y });
	}

	isEmbedable() {
		if(!this.type) {
			return true;
		}
		switch(this.type) {
			case 'twitch':
			case 'youtube':
				return true;
			default:
				return false;
		}
	}

	loadPreviewData() {
		if(this.isPreviewable()) {
			return Promise.resolve();
		}
		switch(this.type) {
			case 'twitch': {
				console.log('here?!?!?');
				return Request.apiv1Get('stream/fetch', { stream_name: this.channel_name })
					.then((response) => {
						this.update(response.stream);
					});
			}
			case 'youtube': {
				return new Promise((resolve, reject) => {
					if(this.id) {
						this.update({
							preview_url: `https://img.youtube.com/vi/${this.id}/0.jpg`
						});
					}
					$.ajax({
						url: 'https://www.googleapis.com/youtube/v3/videos?id=' + this.id + '&key=' + youtubeBrowserApiKey + '&fields=items(snippet(title, description))&part=snippet',
						type: 'GET',
						crossDomain: true,
						dataType: 'jsonp',
						success: (response) => {
							if(response.items) {
								const first = response.items.pop();
								console.log('the item', first);
								this.update({
									channel_name: first.snippet.title,
									title: first.snippet.description
								});
							}
							resolve();
						},
						error: (error) => {
							reject(error);
						}
					});
				});
			}
			case 'image': {

			}
		}
		return Promise.reject();
	}
}

Stream.prototype.dataLocationParsers = {
	id: (stream, data) => {
		stream.id = String(data.id);
	},
	league: (stream, data) => {
		stream.league = League.create(data.league);
	},
	player: (stream, data) => {
		stream.player = Users.update(data.player);
	},
	match: (stream, data) => {
		stream.match = Match.create(data.match);
	},
	smashladder: (stream, data) => {
		if(data.smashladder.game) {
			stream.game = Game.retrieve(data.smashladder.game);
		}
	},
	preview_url: (stream, data) => {
		stream.preview_url = data.preview_url;
		if(stream.preview_url) {
			const replace = ['width', 'height'];
			for(let replacement of replace) {
				stream.preview_url = stream.preview_url.replace(new RegExp('{' + replacement + '}', 'gi'), '128');
			}
		}
	}
};

export { FeaturedStreams, Stream };